import {useEffect, useState} from 'react';
import {Descriptions, InputNumber, Flex} from 'antd';

/**
 * 按月套餐设置
 */
export default function (props){
    const [price, setPrice] = useState(props?.data?.option?.defaultValue?.price/100);
    const [month, setMonth] = useState(props?.data?.option?.defaultValue?.month);
    const [countNum, setCountNum] = useState(props?.data?.option?.defaultValue?.countNum);
    const [agentNum, setAgentNum] = useState(props?.data?.option?.defaultValue?.agentNum);

    useEffect(()=>{
        props.verification(props.data, {
            price: Math.round(price * 100),
            month: month,
            countNum: countNum,
            agentNum: agentNum,
        })
    },[props.data, price, month, countNum, agentNum])

    return <Descriptions
      bordered
      column={1}
      size={"small"}
      labelStyle={{width: "100px"}}
    >
        <Descriptions.item label={'每月价格'}>
            <InputNumber
                style={{width: "100%"}}
                min={0}
                max={999999}
                step={1}
                precision={2}
                controls={false}
                placeholder={'请填写价格'}
                addonAfter={"灵能"}
                value={price}
                onChange={(value) => {
                    setPrice(value)
                }}
            />
        </Descriptions.item>
        <Descriptions.item label={'套餐时长'}>
            <InputNumber
              style={{width: "100%"}}
              min={1}
              max={12}
              step={1}
              precision={0}
              controls={false}
              placeholder={'请填写套餐时长'}
              addonAfter={"个月"}
              value={month}
              onChange={(value) => {
                  setMonth(value)
              }}
            />
        </Descriptions.item>
        <Descriptions.item label={'每月使用上限'}>
            <Flex
                vertical={true}
                gap={5}
            >
                <InputNumber
                  min={0}
                  max={999999}
                  step={1}
                  precision={0}
                  controls={false}
                  placeholder={'请填写调用次数'}
                  addonBefore={<div style={{width: "100px"}}>算力调用次数</div>}
                  addonAfter={"次"}
                  value={countNum}
                  onChange={(value) => {
                      setCountNum(value)
                  }}
                />
                <InputNumber
                  min={0}
                  max={999999}
                  step={1}
                  precision={0}
                  controls={false}
                  placeholder={'请填写调用次数'}
                  addonBefore={<div style={{width: "100px"}}>Agent调用次数</div>}
                  addonAfter={"次"}
                  value={agentNum}
                  onChange={(value) => {
                      setAgentNum(value)
                  }}
                />
            </Flex>
        </Descriptions.item>
    </Descriptions>
}